import React, { Component } from 'react';

import { MailGreen, TelephoneGreen } from '../../assets/images/index.js';

import { Map, Marker, GoogleApiWrapper } from 'google-maps-react';
import { I18n } from 'react-i18next';
import i18n from '../../i18n';

export class ContactMap extends Component {
  render() {
    const style = {
      width: '100%',
      height: '100%',
      position: 'relative'
    };
    return (
      <I18n>{(t, { i18n }) => (
      <div className="contact-map">
        <div className="contact-map__map">
          <Map
            google={this.props.google}
            style={style}
            initialCenter={{
              lat: 51.9974495,
              lng: 4.2572948
            }}
            zoom={14}
            disableDefaultUI={true}>
            <Marker
              name={'Forever Plants Group'}
              position={{
                lat: 37.759703,
                lng: -122.428093
              }}
            />
            <Marker />
          </Map>
        </div>
        <div className="contact-map__text">
          <h4>FOREVER PLANTS GROUP</h4>
          <span>Zwethlaan 40</span>
          <span>2675 LB Honselersdijk</span>
          <a
            href="https://goo.gl/JZJxKr"
            alt="Routebeschrijving"
            target="_blank"
            rel="noopener noreferrer">
            {t('contactRouteHref')}
          </a>
          <div className="contact-map__contact">
            <a href="mailto:hallo@foreverplants.nl">
              <MailGreen /> hallo@foreverplants.nl
            </a>
            <br />
            <a href="tel:+31174622668">
              <TelephoneGreen /> 0174 - 622 668
            </a>
          </div>
        </div>
      </div>
      )}</I18n>
    );
  }
}

export default GoogleApiWrapper({
  apiKey: 'AIzaSyD-Clw29cJjVZYWqfUNVeSnxSFPmRnJS3s'
})(ContactMap);



// WEBPACK FOOTER //
// ./src/components/ContactMap/Map.jsx